import { api } from './api';
import { useAuthStore } from '../store/authStore';

export interface TemplateTicket {
  id: number;
  tenantId: number;
  sucursalId?: number;
  name: string;
  tipo: 'ticket' | 'factura' | 'cotizacion' | 'nota_credito';
  formato: 'texto' | 'html' | 'pdf';
  template: string;
  header?: string;
  footer?: string;
  anchoImpresora: number;
  isDefault: boolean;
  isActive: boolean;
}

export interface TicketImpreso {
  id: number;
  ordenId: number;
  templateId?: number;
  tipo: string;
  formato: string;
  contenido?: string;
  usuarioId?: number;
  impresoEn: string;
}

export const ticketService = {
  generarTicket: async (ordenId: number, formato: 'texto' | 'html' | 'pdf' = 'texto', templateId?: number): Promise<Blob> => {
    const params = new URLSearchParams();
    params.append('formato', formato);
    if (templateId) params.append('templateId', templateId.toString());
    
    // Obtener token del store
    const token = useAuthStore.getState().token;
    const response = await fetch(`${import.meta.env.VITE_API_URL || 'http://localhost:3001/api'}/tickets/orden/${ordenId}?${params.toString()}`, {
      headers: {
        'Authorization': token ? `Bearer ${token}` : '',
      }
    });
    
    if (!response.ok) {
      throw new Error('Error al generar ticket');
    }
    
    return await response.blob();
  },

  getTemplates: async (tipo?: string, sucursalId?: number): Promise<{ data: { templates: TemplateTicket[] } }> => {
    const params = new URLSearchParams();
    if (tipo) params.append('tipo', tipo);
    if (sucursalId) params.append('sucursalId', sucursalId.toString());
    
    const response = await api.get<{ data: { templates: TemplateTicket[] } }>(`/tickets/templates?${params.toString()}`);
    return response.data;
  },

  getHistorial: async (ordenId?: number): Promise<{ data: { tickets: TicketImpreso[] } }> => {
    const params = new URLSearchParams();
    if (ordenId) params.append('ordenId', ordenId.toString());
    
    const response = await api.get<{ data: { tickets: TicketImpreso[] } }>(`/tickets/historial?${params.toString()}`);
    return response.data;
  },

  imprimirTicket: async (ordenId: number, formato: 'texto' | 'html' | 'pdf' = 'texto', templateId?: number) => {
    const blob = await ticketService.generarTicket(ordenId, formato, templateId);
    
    if (formato === 'html' || formato === 'pdf') {
      // Abrir en nueva ventana para imprimir
      const url = URL.createObjectURL(blob);
      const window = open(url, '_blank');
      if (window) {
        window.onload = () => {
          window.print();
        };
      }
    } else {
      // Descargar archivo de texto
      const url = URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url;
      a.download = `ticket-${ordenId}.txt`;
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
      URL.revokeObjectURL(url);
    }
  },

  verTicket: async (ordenId: number, formato: 'texto' | 'html' | 'pdf' = 'html', templateId?: number) => {
    const blob = await ticketService.generarTicket(ordenId, formato, templateId);
    const url = URL.createObjectURL(blob);
    const window = open(url, '_blank');
    if (window) {
      setTimeout(() => URL.revokeObjectURL(url), 100);
    }
  }
};

